import { useState } from "react";
import { Link } from "react-router-dom";
import { Search, MapPin } from "lucide-react";
import { Input } from "@/components/ui/input";
import { COUNTRIES } from "@/lib/data";

export default function CountryIntel() {
  const [query, setQuery] = useState("");
  const filtered = COUNTRIES.filter((c) => c.toLowerCase().includes(query.toLowerCase()));

  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-[#0050A0] mb-3">192 UPU Member Countries</p>
          <h1 className="font-serif text-4xl text-slate-900">Country Intelligence</h1>
          <p className="text-sm text-slate-500 mt-3 max-w-2xl leading-relaxed">
            Deep-dive procurement profiles per country: national procurement laws updated to the latest status,
            past postal tender landscape, compliance risks and UN framework applicability.
          </p>
        </div>
        <div className="relative w-full md:w-80">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" aria-hidden="true" />
          <Input
            data-testid="country-search-input"
            className="bg-white border-slate-300 pl-9"
            placeholder="Search a country…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="bg-white border border-slate-200 p-16 text-center" data-testid="country-empty-state">
          <p className="text-slate-500">No UPU member country matches "{query}".</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-t border-l border-slate-200 bg-white">
          {filtered.map((c, i) => (
            <Link
              key={c}
              to={`/countries/${encodeURIComponent(c)}`}
              data-testid={`country-card-${i}`}
              className="border-b border-r border-slate-200 p-5 flex items-center gap-3 hover:bg-[#E6F0F9] transition-colors duration-200"
            >
              <MapPin className="w-4 h-4 text-[#009EDB] shrink-0" aria-hidden="true" />
              <span className="text-sm font-medium text-slate-800">{c}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
